export const SHOW_FACE_CHECK_MODAL = 'SHOW_FACE_CHECK_MODAL';
export const HIDE_FACE_CHECK_MODAL = 'HIDE_FACE_CHECK_MODAL';
export const IDENTITY_SESSION_SET_LOADING = 'IDENTITY_SESSION_SET_LOADING';
export const IDENTITY_SESSION_ERROR = 'IDENTITY_SESSION_ERROR';

export type ShowFaceCheckModal = {
  type: 'SHOW_FACE_CHECK_MODAL';
};

export type HideFaceCheckModal = {
  type: 'HIDE_FACE_CHECK_MODAL';
};

export type IdentitySessionSetLoading = {
  type: 'IDENTITY_SESSION_SET_LOADING';
  loading: boolean;
};

export type IdentitySessionError = {
  type: 'IDENTITY_SESSION_ERROR';
  message: string | null;
};

export type IdentitySessionActions =
  | ShowFaceCheckModal
  | HideFaceCheckModal
  | IdentitySessionSetLoading
  | IdentitySessionError;
